import { createAllRangeDates, mapCurrentDataToTimestampsMap, negative, SUMMARY_ROW_ID, } from '@fourthwall/module-analytics';
export const createChartStatsTableProfit = (current, params) => {
    if (!current)
        return [];
    const allRangeDates = createAllRangeDates(params).reverse();
    const grossSales = mapCurrentDataToTimestampsMap(current.grossSales?.data);
    const discounts = mapCurrentDataToTimestampsMap(current.discounts?.data);
    const costs = mapCurrentDataToTimestampsMap(current.cost?.data);
    const cancellations = mapCurrentDataToTimestampsMap(current.cancellations?.data);
    const refunds = mapCurrentDataToTimestampsMap(current.refunds?.data);
    const profits = mapCurrentDataToTimestampsMap(current.profit?.data);
    const statsTableData = allRangeDates.map((date) => ({
        id: date,
        day: date,
        grossSales: grossSales[date] || 0,
        discounts: negative(discounts[date]) || 0,
        cost: negative(costs[date]) || 0,
        cancellations: negative(cancellations[date]) || 0,
        refunds: negative(refunds[date]) || 0,
        profit: profits[date] || 0,
    }));
    statsTableData.unshift({
        id: SUMMARY_ROW_ID,
        day: 'Summary',
        grossSales: current.grossSales?.aggregatedValue || 0,
        discounts: negative(current.discounts?.aggregatedValue) || 0,
        cost: negative(current.cost?.aggregatedValue) || 0,
        cancellations: negative(current.cancellations?.aggregatedValue) || 0,
        refunds: negative(current.refunds?.aggregatedValue) || 0,
        profit: current.profit?.aggregatedValue || 0,
    });
    return statsTableData;
};
